import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/gentou.jpg'
import _imports_1 from '@/assets/images/icons/sumita.jpg'
import _imports_2 from '@/assets/images/icons/kurotori.png'
import _imports_3 from '@/assets/images/icons/inapu.png'
import _imports_4 from '@/assets/images/icons/nennnn.jpg'
import _imports_5 from '@/assets/images/icons/jmof.png'
import _imports_6 from '@/assets/images/icons/loisirhoteltoyohashi.png'
import _imports_7 from '@/assets/images/icons/kemoclub.png'
import _imports_8 from '@/assets/images/icons/giwa.jpg'
import _imports_9 from '@/assets/images/icons/yeshi.jpg'
import _imports_10 from '@/assets/images/icons/uniuni.jpg'
import _imports_11 from '@/assets/images/icons/hy.jpg'
import _imports_12 from '@/assets/images/icons/lura.jpg'
import _imports_13 from '@/assets/images/icons/gigash.jpg'
import _imports_14 from '@/assets/images/icons/noimage.jpg'
import _imports_15 from '@/assets/images/icons/quadruped.png'
import _imports_16 from '@/assets/images/icons/kemonap.jpg'
import _imports_17 from '@/assets/images/icons/yamakami.jpg'


const _withScopeId = n => (_pushScopeId("data-v-aef22d96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-credit" }
const _hoisted_2 = { class: "credit-list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "credit-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/gen_tou",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "credit-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/alcoholic_wolf",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_10 = { class: "credit-text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/kurotori4423",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_13 = { class: "credit-text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/reo_inoko",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_16 = { class: "credit-text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/nennnn4",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  })
], -1))
const _hoisted_19 = { class: "credit-text" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.jmof.jp/",
    target: "_blank"
  }, "Website")
], -1))
const _hoisted_21 = { class: "credit-list" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_23 = { class: "credit-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.loisir-toyohashi.com/",
    target: "_blank"
  }, "Website")
], -1))
const _hoisted_25 = { class: "credit-list" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })
], -1))
const _hoisted_27 = { class: "credit-text" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://kemo.club/",
    target: "_blank"
  }, "Website")
], -1))
const _hoisted_29 = { class: "credit-list" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: ""
  })
], -1))
const _hoisted_31 = { class: "credit-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/G1wa_",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_33 = { class: "credit-list" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: ""
  })
], -1))
const _hoisted_35 = { class: "credit-text" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/Yeshi_hobby",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_37 = { class: "credit-list" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    alt: ""
  })
], -1))
const _hoisted_39 = { class: "credit-text" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://uniunishop.booth.pm/",
    target: "_blank",
    class: "link-bt"
  }, "Booth")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/lept_on",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  })
], -1))
const _hoisted_43 = { class: "credit-text" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/hd4tails",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_45 = { class: "credit-list" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    alt: ""
  })
], -1))
const _hoisted_47 = { class: "credit-text" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/Lu_Ra_999",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_49 = { class: "credit-list" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_13,
    alt: ""
  })
], -1))
const _hoisted_51 = { class: "credit-text" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://gigasuke-shokai.booth.pm/",
    target: "_blank",
    class: "link-bt"
  }, "Booth")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/gigash",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_14,
    alt: ""
  })
], -1))
const _hoisted_55 = { class: "credit-text" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://cwwdog.booth.pm/",
    target: "_blank",
    class: "link-bt"
  }, "Booth")
], -1))
const _hoisted_57 = { class: "credit-list" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_14,
    alt: ""
  })
], -1))
const _hoisted_59 = { class: "credit-text" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.milkpot-fursuit.com/",
    target: "_blank"
  }, "Website")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_15,
    alt: ""
  })
], -1))
const _hoisted_62 = { class: "credit-text" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://quadruped.booth.pm/",
    target: "_blank",
    class: "link-bt"
  }, "Booth")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_16,
    alt: ""
  })
], -1))
const _hoisted_65 = { class: "credit-text" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://kemonap.booth.pm/",
    target: "_blank",
    class: "link-bt"
  }, "Booth")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/Kemonap_",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_17,
    alt: ""
  })
], -1))
const _hoisted_69 = { class: "credit-text" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://anaguraworks.booth.pm",
    target: "_blank",
    class: "link-bt"
  }, "Booth")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/yamakami_gm",
    target: "_blank",
    class: "link-tw"
  }, "Twitter")
], -1))
const _hoisted_72 = { class: "update-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-others" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", null, [
              _hoisted_3,
              _createElementVNode("dl", _hoisted_4, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'gentou')), 1),
                _hoisted_5
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_6,
              _createElementVNode("dl", _hoisted_7, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'sumita')), 1),
                _hoisted_8
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_9,
              _createElementVNode("dl", _hoisted_10, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'kurotori')), 1),
                _hoisted_11
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_12,
              _createElementVNode("dl", _hoisted_13, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'inapu')), 1),
                _hoisted_14
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_15,
              _createElementVNode("dl", _hoisted_16, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'nennnn')), 1),
                _hoisted_17
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_18,
              _createElementVNode("dl", _hoisted_19, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'jmof')), 1),
                _hoisted_20
              ])
            ])
          ]),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_21, [
            _createElementVNode("li", null, [
              _hoisted_22,
              _createElementVNode("dl", _hoisted_23, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'loisir')), 1),
                _hoisted_24
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_25, [
            _createElementVNode("li", null, [
              _hoisted_26,
              _createElementVNode("dl", _hoisted_27, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'kemo_club')), 1),
                _hoisted_28
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_29, [
            _createElementVNode("li", null, [
              _hoisted_30,
              _createElementVNode("dl", _hoisted_31, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'giwa')), 1),
                _hoisted_32
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_4')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_33, [
            _createElementVNode("li", null, [
              _hoisted_34,
              _createElementVNode("dl", _hoisted_35, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'yeshi')), 1),
                _hoisted_36
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_5')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_37, [
            _createElementVNode("li", null, [
              _hoisted_38,
              _createElementVNode("dl", _hoisted_39, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'uniuni')), 1),
                _hoisted_40,
                _hoisted_41
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_42,
              _createElementVNode("dl", _hoisted_43, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'hy')), 1),
                _hoisted_44
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_6')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_45, [
            _createElementVNode("li", null, [
              _hoisted_46,
              _createElementVNode("dl", _hoisted_47, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'virtual_fox')), 1),
                _hoisted_48
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_7')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_49, [
            _createElementVNode("li", null, [
              _hoisted_50,
              _createElementVNode("dl", _hoisted_51, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'gigasuke_shokai')), 1),
                _hoisted_52,
                _hoisted_53
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_54,
              _createElementVNode("dl", _hoisted_55, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'suiken')), 1),
                _hoisted_56
              ])
            ])
          ]),
          _createVNode(_component_Heading, {
            class: "field-name",
            tag: "h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_8')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_57, [
            _createElementVNode("li", null, [
              _hoisted_58,
              _createElementVNode("dl", _hoisted_59, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'milkpot')), 1),
                _hoisted_60
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_61,
              _createElementVNode("dl", _hoisted_62, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'quadruped_quartet')), 1),
                _hoisted_63
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_64,
              _createElementVNode("dl", _hoisted_65, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'kemonap')), 1),
                _hoisted_66,
                _hoisted_67
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_68,
              _createElementVNode("dl", _hoisted_69, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('list', 'anagura_works')), 1),
                _hoisted_70,
                _hoisted_71
              ])
            ])
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_72, _toDisplayString(_ctx.$props.i18n.$text('update_date')), 1)
        ])
      ]),
      _: 1
    })
  ], 64))
}